// * ========================================================================
// * Scroll to top button that comes visible after scrolling
// * ========================================================================

export default (function() {

  function init () {
    const topLink = document.getElementById('scroll-top');

    document.addEventListener('scroll', function(e) {
      const scrollPosition = window.scrollY;
      if(scrollPosition > window.innerHeight) {
        topLink.classList.add('visible');
      } else {
        topLink.classList.remove('visible');
      }
    });
  }

  return {
    init: init
  };

})();
